var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInvite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A2A7B3",
  d: "M22 21.582V8.665l-9.16-5.343a1.67 1.67 0 0 0-1.68 0L2 8.665v12.917z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.139 6.998 3.25 10.988l2.186 8.273 14.89-3.99z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D1D5DD",
  d: "M8.667 19.428 2 21.582V8.665l6.413 6.213a.83.83 0 0 1 .254.599zm6.666 0L22 21.582V8.665l-6.413 6.213a.83.83 0 0 0-.254.599z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#E5E7EC",
  d: "M22 21.79H2l6.472-6.624a.83.83 0 0 1 .596-.25h5.513c.448 0 .878.18 1.192.501z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF6562",
  d: "M13.345 10.515a1.07 1.07 0 0 0-.604-.183 1 1 0 0 0-.52.154q-.149.096-.252.211l-.125-.103a1.1 1.1 0 0 0-.693-.236.96.96 0 0 0-.679.281c-.385.391-.436.944-.145 1.557.191.402.582.767.876 1.003.203.163.457.35.641.428l-.002.003a.33.33 0 0 0 .283.005c.097-.044.262-.148.567-.399.251-.206.603-.528.855-.89.146-.207.246-.467.289-.75.06-.399-.142-.843-.491-1.081"
})));
export default SvgInvite;